import React from "react";
import { Link } from "react-router-dom";
import { useInsertName } from "./utils/helpers";

import { MonoButton, PaperBG} from "../kits/DesignKit";

const NotFound = () => {
    const name = useInsertName();
    
  return (


    <PaperBG>
    <div className="flex flex-col items-center justify-center h-screen text-gray-800 font-mono">
      {/* Fehlercode */}
  
      <h2 >
        Oops! <span className="">da ist nix</span>  <span className="text-orange-50 " >{name}</span>
      </h2>
    
      {/* Untertitel */}
      <p className="text-center mb-8 px-6 sm:px-0 text-gray-800 text-xs font-mono">
        so was blödes, die Seite, die du suchst,<br />existiert nicht oder wurde verschoben.{" "}
      </p>

       


      {/* Dekoratives Bild */}
      <div className="mt-10">
        <img
          src={`${process.env.PUBLIC_URL}/images/not-found.png`} // Ersetze durch dein Bild
          alt="404 Illustration"
          className="w-64 h-64 mx-auto animate-float filter grayscale"
        />
      </div>
      <MonoButton className="mt-10 text-xs">
  <Link to="/" className="text-center">
    Zurück zur Startseite
  </Link>
</MonoButton>
    </div>
    
    </PaperBG>
  );

};

export default NotFound;